import { LatLng } from "use-places-autocomplete";
import { useCustomerAnalytics } from "../../../services/hooks/useCustomerAnalytics";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import {
  LoadingActionEnum,
  decreasePendingOperations,
  increasePendingOperations,
  pushToLoadingStack,
  setAnimatedGlobalBannerState,
  setLoading,
} from "../../../services/redux/slices/globalComponentsToggleSlice";
import { CUSTOMER_ANALYTICS_EVENT } from "../../../utils/enums";
import { LocationIcon } from "../../screens/S-Address/icons";
import styles from "./DetectLocation.module.scss";

function DetectLocation(props: { onSuccess: (lngLat: LatLng) => void }) {
  const { t } = useTranslationI18();
  const addCustomerAnalytics = useCustomerAnalytics();

  const dispatch = useAppDispatch();
  const enableLocTranslation = t("delivery:enable-location");
  const connectionTranslation = t("delivery:connection-timeout");
  const detectLocation = t("table-page:detect-closes-branch");
  const restaurantConfig = useAppSelector(
    (state) => state.config.restaurantInfo
  )?.config;
  function success(pos: any) {
    const crd = pos.coords;
    if (restaurantConfig?.loadingStateSolution) {
      dispatch(
        pushToLoadingStack({
          action: LoadingActionEnum.DECREASE,
          functionName: "DetectLocation getCurrentPosition success",
          date: new Date(),
        })
      );
      dispatch(decreasePendingOperations());
    } else {
      dispatch(setLoading(false));
    }
    props.onSuccess({ lat: crd.latitude, lng: crd.longitude });
  }

  function handleError(err: any, tries: number) {
    if (tries < 2) {
      return getCurrentPosition(tries + 1);
    }
    let text;
    switch (err.code) {
      case 1:
        text = enableLocTranslation;
        break;
      case 3:
        text = connectionTranslation;

        break;
      default:
        text = "Something went wront";
        break;
    }
    if (restaurantConfig?.loadingStateSolution) {
      dispatch(
        pushToLoadingStack({
          action: LoadingActionEnum.DECREASE,
          functionName: "DetectLocation getCurrentPosition error",
          date: new Date(),
        })
      );
      dispatch(decreasePendingOperations());
    } else {
      dispatch(setLoading(false));
    }
    dispatch(
      setAnimatedGlobalBannerState({
        isOpen: true,
        text: text,
        warning: true,
      })
    );

    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  const getCurrentPosition = (tries: number) => {
    if (restaurantConfig?.loadingStateSolution) {
      dispatch(
        pushToLoadingStack({
          action: LoadingActionEnum.INCREASE,
          functionName: "DetectLocation getCurrentPosition",
          date: new Date(),
        })
      );
      dispatch(increasePendingOperations());
    } else {
      dispatch(setLoading(true));
    }

    navigator.geolocation.getCurrentPosition(
      success,
      (err) => handleError(err, tries),
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  return (
    <div
      onClick={() => {
        addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.DETECT_CLOSEST_BRANCH);
        getCurrentPosition(0);
      }}
      data-testid={"detect_location"}
      className={styles.detect_location}
    >
      <LocationIcon /> {detectLocation}
    </div>
  );
}

export default DetectLocation;
